export default "__VITE_ASSET__Mb_ZxWOE__"